module.exports = __webpack_public_path__ + "static/media/skirting.b2e1db05.svg";